import { apiCallback } from 'api';

const definition = {
  service: 'branch',
  endpoint: 'branches/${branchId}',
  verbs: ['get'],
  defaultVersion: 4,
};

export default {
  get: apiCallback(definition, 'get'),
};
